import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { Toaster } from 'sonner';

// Public pages
import { Hero } from './pages/Hero';
import { BookingWizard } from './pages/BookingWizard';
import { Step1_SelectVehicle } from './pages/Step1_SelectVehicle';
import { Step2_ServiceDetails } from './pages/Step2_ServiceDetails';
import { Step3_Confirmation } from './pages/Step3_Confirmation';
import { Step4_Payment } from './pages/Step4_Payment';
import { ConfirmationPage } from './pages/ConfirmationPage';
import { WhatsAppButton } from './components/WhatsAppButton';
import { ClientHeader } from './components/ClientHeader';
import { ClientFooter } from './components/ClientFooter';

// Admin pages
import { AdminLogin } from './pages/admin/AdminLogin';
import { AdminLayout } from './pages/admin/AdminLayout';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { AdminVehicles } from './pages/admin/AdminVehicles';
import { AdminRoutesPage } from './pages/admin/AdminRoutesPage';
import { AdminRatesPage } from './pages/admin/AdminRatesPage';
import { AdminAddonsPage } from './pages/admin/AdminAddonsPage';
import { AdminReservations } from './pages/admin/AdminCRUD';

const ClientLayout = () => (
  <div className="flex flex-col min-h-screen">
    <ClientHeader />
    <main className="flex-1">
      <Outlet />
    </main>
    <ClientFooter />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes — wrapped with Header + Footer */}
          <Route element={<ClientLayout />}>
            <Route path="/" element={<Hero />} />
            <Route path="/booking" element={<BookingWizard />} />
            <Route path="/booking/select-vehicle" element={<Step1_SelectVehicle />} />
            <Route path="/booking/service-details" element={<Step2_ServiceDetails />} />
            <Route path="/booking/confirmation" element={<Step3_Confirmation />} />
            <Route path="/booking/payment" element={<Step4_Payment />} />
            <Route path="/confirmation/:reservationId" element={<ConfirmationPage />} />
          </Route>

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="vehicles" element={<AdminVehicles />} />
            <Route path="routes" element={<AdminRoutesPage />} />
            <Route path="rates" element={<AdminRatesPage />} />
            <Route path="addons" element={<AdminAddonsPage />} />
            <Route path="reservations" element={<AdminReservations />} />
          </Route>

          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <WhatsAppButton />
      </BrowserRouter>

      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
